import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as CommitteeMemberActions from "../../../actions/committeeMember";
import * as CommitteeMemberRoleActions from "../../../actions/committeeMemberRole";
import * as CommitteeActions from "../../../actions/committees";
import * as NavigationActions from "../../../actions/navigation";
import { NotificationAlert } from "../../../components/common/index";
import { DatePickerFormInputFabric, TextAreaFormInput } from "../../../components/form";
import { SelectFormInput } from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { CommitteeMemberRoleCreateBreadcrumbs, CommitteeMemberRoleDetailsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { findLookup, findLookupValue, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { CommitteeMemberRoleSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./CommitteeMemberRolePage.scss";

interface CommitteeMemberRolePageProps {
    form: Dtos.CommitteeMemberRole & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    committeeMemberRole: Dtos.CommitteeMemberRole;
    committeeMember: Dtos.CommitteeMember | undefined;
    committee: Dtos.Committee | undefined;
    lookups: Dtos.Lookup[];
    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;
    loadCommitteeErrorCode: string;
    loadingCommitteeMember: boolean;
    loadCommitteeMemberSuccess: boolean;
    loadCommitteeMemberFailure: boolean;
    loadCommitteeMemberErrorCode: string;
    loadingCommitteeMemberRole: boolean;
    loadCommitteeMemberRoleSuccess: boolean;
    loadCommitteeMemberRoleFailure: boolean;
    loadCommitteeMemberRoleErrorCode: string;
    savingCommitteeMemberRole: boolean;
    saveCommitteeMemberRoleSuccess: boolean;
    saveCommitteeMemberRoleFailure: boolean;
    creatingCommitteeMemberRole: boolean;
    validatingCommitteeMemberRole: boolean;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearCommitteeMemberRole: CommitteeMemberRoleActions.ICommitteeMemberRoleClearActionCreator;
    loadCommitteeMemberRole: CommitteeMemberRoleActions.ICommitteeMemberRoleLoadByIdActionCreator;
    saveCommitteeMemberRole: CommitteeMemberRoleActions.ICommitteeMemberRoleSaveActionCreator;
    createCommitteeMemberRole: CommitteeMemberRoleActions.ICommitteeMemberRoleCreateActionCreator;
    validateCommitteeMemberRole: CommitteeMemberRoleActions.ICommitteeMemberRoleValidateActionCreator;
    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;
    clearCommitteeMember: CommitteeMemberActions.ICommitteeMemberClearActionCreator;
    loadCommitteeMember: CommitteeMemberActions.ICommitteeMemberLoadByIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.committeeMemberRole";

const CommitteeMemberRolePage: FC<CommitteeMemberRolePageProps> = ({
    form,
    formState,
    formProperties,
    committeeMemberRole,
    committeeMember,
    committee,
    lookups,
    loadingCommittee,
    //loadCommitteeSuccess,
    loadCommitteeFailure,
    loadCommitteeErrorCode,
    loadingCommitteeMember,
    //loadCommitteeMemberSuccess,
    loadCommitteeMemberFailure,
    loadCommitteeMemberErrorCode,
    loadingCommitteeMemberRole,
    //loadCommitteeMemberRoleSuccess,
    loadCommitteeMemberRoleFailure,
    loadCommitteeMemberRoleErrorCode,
    savingCommitteeMemberRole,
    saveCommitteeMemberRoleSuccess,
    saveCommitteeMemberRoleFailure,
    creatingCommitteeMemberRole,
    validatingCommitteeMemberRole,
    validationFailures,
    permissions,
    clearCommitteeMemberRole,
    loadCommitteeMemberRole,
    saveCommitteeMemberRole,
    createCommitteeMemberRole,
    validateCommitteeMemberRole,
    clearCommittee,
    loadCommittee,
    clearCommitteeMember,
    loadCommitteeMember,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { committeeId } = useParams<{ committeeId: string }>();
    const { committeeMemberId } = useParams<{ committeeMemberId: string }>();
    const { committeeMemberRoleId } = useParams<{ committeeMemberRoleId: string }>();
    const committeeIdNumber = parseInt(committeeId, 10);
    const committeeMemberIdNumber = parseInt(committeeMemberId, 10);
    const committeeMemberRoleIdNumber = parseInt(committeeMemberRoleId, 10);

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();

    const loadReduxForm = () => {
        let extraData: Dtos.CommitteeMemberRole = {} as Dtos.CommitteeMemberRole;

        loadForm(reduxFormName, Object.assign({ ...committeeMemberRole }, extraData));
    };


    // Load or Create CommitteeMemberRole
    useEffect(() => {
        if (
            committeeIdNumber &&
            committeeMemberIdNumber &&
            committeeMemberRoleIdNumber &&
            !committeeMemberRole &&
            !loadingCommitteeMemberRole
        ) {
            setBreadcrumbs(
                CommitteeMemberRoleDetailsBreadcrumbs(
                    committeeIdNumber,
                    committeeMemberIdNumber,
                    committeeMemberRoleIdNumber
                )
            );
            setDrawerItems(
                CommitteeMemberRoleSubMenu(
                    committeeIdNumber,
                    committeeMemberIdNumber,
                    committeeMemberRoleIdNumber,
                    permissions
                )
            );

            loadCommitteeMemberRole(committeeMemberRoleIdNumber);
        } else if (
            committeeIdNumber &&
            committeeMemberIdNumber &&
            !committeeMemberRoleIdNumber &&
            !committeeMemberRole &&
            !creatingCommitteeMemberRole
        ) {
            setDrawerItems([]);
            setBreadcrumbs(
                CommitteeMemberRoleCreateBreadcrumbs(
                    committeeIdNumber,
                    committeeMemberIdNumber
                )
            );

            if (committeeMember?.personnelId) {
                createCommitteeMemberRole(committeeIdNumber, committeeMember.personnelId);
            }
        }
    }, [
        committeeIdNumber,
        committeeMemberIdNumber,
        committeeMemberRoleIdNumber,
        committeeMember,
        committeeMemberRole,
        loadingCommitteeMemberRole,
        creatingCommitteeMemberRole,
    ]);

    // Initialise form once role is loaded
    useEffect(() => {
        if (committeeMemberRole && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }
    }, [committeeMemberRole, formInitalised]);

    // Load Committee
    useEffect(() => {
        if (committeeIdNumber && !committee && !loadingCommittee) {
            loadCommittee(committeeIdNumber);
        }
    }, [committeeIdNumber, committee, loadingCommittee]);

    // Load CommitteeMember
    useEffect(() => {
        if (committeeMemberIdNumber && !committeeMember && !loadingCommitteeMember) {
            loadCommitteeMember(committeeMemberIdNumber);
        }
    }, [committeeMemberIdNumber, committeeMember, loadingCommitteeMember]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadCommitteeFailure) {
            navigate(`/error/${loadCommitteeErrorCode}`);
        }
        if (loadCommitteeMemberFailure) {
            navigate(`/error/${loadCommitteeMemberErrorCode}`);
        }
        if (loadCommitteeMemberRoleFailure) {
            navigate(`/error/${loadCommitteeMemberRoleErrorCode}`);
        }
    }, [
        loadCommitteeFailure,
        loadCommitteeErrorCode,
        loadCommitteeMemberFailure,
        loadCommitteeMemberErrorCode,
        loadCommitteeMemberRoleFailure,
        loadCommitteeMemberRoleErrorCode
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (committee && committeeMember && committeeMemberRole && committeeMemberRoleIdNumber) {
            setBreadcrumbs(
                CommitteeMemberRoleDetailsBreadcrumbs(
                    committee.id,
                    committeeMember.id,
                    committeeMemberRole.id,
                    committee.name,
                    `${
                        findLookupValue(
                            "Personnel",
                            "SalutationId",
                            committeeMember?.personnel?.salutationId,
                            lookups
                        ) ?? ""
                    } ${committeeMember?.personnel?.displayWithSalutation}`,
                    committeeMemberRole?.committeeMemberRoleType?.value
                )
            );
        } else if (committee && committeeMember && !committeeMemberRoleIdNumber) {
            setDrawerItems([]);
            setBreadcrumbs(
                CommitteeMemberRoleCreateBreadcrumbs(
                    committee.id,
                    committeeMember.id,
                    committee?.name,
                    `${
                        findLookupValue(
                            "Personnel",
                            "SalutationId",
                            committeeMember?.personnel?.salutationId,
                            lookups
                        ) ?? ""
                    } ${committeeMember?.personnel?.displayWithSalutation}`
                )
            );
        }
    }, [
        committee,
        committeeMember,
        committeeMemberRole,
        committeeMemberRoleIdNumber
    ]);

    // Reload after saving
    useEffect(() => {
        if (!savingCommitteeMemberRole && saveCommitteeMemberRoleSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Committee Member Role saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/committees/${committeeIdNumber}/members/${committeeMemberIdNumber}/roles`);
            } else if (!committeeMemberRoleIdNumber) {
                navigate(`/committees/${committeeIdNumber}/members/${committeeMemberIdNumber}/roles/${committeeMemberRole?.id}/details`);
            }
        }
    }, [
        savingCommitteeMemberRole,
        saveCommitteeMemberRoleSuccess,
        saveAndReturn
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingCommitteeMemberRole && saveCommitteeMemberRoleFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [
        savingCommitteeMemberRole,
        saveCommitteeMemberRoleFailure
    ]);

    // Cleanup effect to clear the committee/member/role on component unmount
    useEffect(() => {
        return () => {
            clearCommittee();
            clearCommitteeMember();
            clearCommitteeMemberRole();
            resetForm(reduxFormName);
        };
    }, []);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.CommitteeMemberRole = {} as Dtos.CommitteeMemberRole;

            saveCommitteeMemberRole(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.CommitteeMemberRole) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate(`/committees/${committeeIdNumber}/members/${committeeMemberIdNumber}/roles`);
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.CommitteeMemberRole = {} as Dtos.CommitteeMemberRole;

            if (form && hasBeenSubmitted && !validatingCommitteeMemberRole) {
                await validateCommitteeMemberRole(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form, hasBeenSubmitted, validatingCommitteeMemberRole]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.CommitteeMemberRoleUpdate
        );
        const formDisabled: boolean =
            !hasPermission ||
            savingCommitteeMemberRole ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeMemberRole",
                                        {
                                            committeeMemberRoleTypeId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "committeeMemberRole",
                                                                "committeeMemberRoleTypeId",
                                                                lookups
                                                            ),
                                                            form.committeeMemberRoleTypeId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-10 generic-form-field mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "committeeMemberRole",
                                        {
                                            dateStarted: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-4",
                                                fieldClassName: "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "committeeMemberRole",
                                        {
                                            dateCeased: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-4",
                                                fieldClassName: "col-sm-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            commentGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Comments</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeMemberRole",
                                        {
                                            comments: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName: "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "committeeMemberRole",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={onCancel}
                        className="btn btn-primary mr-2"
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        permissions,
        savingCommitteeMemberRole,
        formState,
        form,
        lookups,
        validationFailures,
        formProperties
    ]);

    return (
        <RestrictedLayout
            loading={
                loadingCommittee ||
                loadingCommitteeMember ||
                loadingCommitteeMemberRole || 
                creatingCommitteeMemberRole
            }
            permission={Dtos.Permission.CommitteeMemberRoleView}
        >
            { renderContent }
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<CommitteeMemberRolePageProps> => {
    let committeeMemberRole: Dtos.CommitteeMemberRole | undefined = 
        !(state.committeeMemberRole.formData instanceof Array)
            ? state.committeeMemberRole.formData
            : undefined;
    let committeeMember: Dtos.CommitteeMember | undefined = 
        !(state.committeeMember.formData instanceof Array)
            ? state.committeeMember.formData
            : undefined;
    let committee: Dtos.Committee | undefined = 
        !(state.committees.formData instanceof Array)
            ? state.committees.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        committeeMemberRole: committeeMemberRole!,
        committeeMember: committeeMember!,
        committee: committee!,
        loadingCommittee:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Failure,
        loadCommitteeErrorCode: state.committees.loadState.errorCode,

        loadingCommitteeMember:
            state.committeeMember.loadState &&
            state.committeeMember.loadState.status == RequestState.Pending,
        loadCommitteeMemberSuccess:
            state.committeeMember.loadState &&
            state.committeeMember.loadState.status == RequestState.Success,
        loadCommitteeMemberFailure:
            state.committeeMember.loadState &&
            state.committeeMember.loadState.status == RequestState.Failure,
        loadCommitteeMemberErrorCode: state.committeeMember.loadState.errorCode,

        loadingCommitteeMemberRole:
            state.committeeMemberRole.loadState &&
            state.committeeMemberRole.loadState.status == RequestState.Pending,
        loadCommitteeMemberRoleSuccess:
            state.committeeMemberRole.loadState &&
            state.committeeMemberRole.loadState.status == RequestState.Success,
        loadCommitteeMemberRoleFailure:
            state.committeeMemberRole.loadState &&
            state.committeeMemberRole.loadState.status == RequestState.Failure,
        loadCommitteeMemberRoleErrorCode: state.committeeMemberRole.loadState.errorCode,

        savingCommitteeMemberRole:
            state.committeeMemberRole.saveState &&
            state.committeeMemberRole.saveState.status == RequestState.Pending,
        saveCommitteeMemberRoleSuccess:
            state.committeeMemberRole.saveState &&
            state.committeeMemberRole.saveState.status == RequestState.Success,
        saveCommitteeMemberRoleFailure:
            state.committeeMemberRole.saveState &&
            state.committeeMemberRole.saveState.status == RequestState.Failure,

        creatingCommitteeMemberRole:
            state.committeeMemberRole.createState &&
            state.committeeMemberRole.createState.status == RequestState.Pending,

        validatingCommitteeMemberRole:
            state.committeeMemberRole.validateState &&
            state.committeeMemberRole.validateState.status == RequestState.Pending,

        permissions: permissions,
        lookups: state.committeeMemberRole.lookups,

        form: state.reduxForms.committeeMemberRole,
        formState: state.committeeMemberRole.formState,
        formProperties: state.committeeMemberRole.formProperties,

        validationFailures: committeeMemberRole
            ? state.committeeMemberRole.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<CommitteeMemberRolePageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadCommitteeMemberRole: bindActionCreators(CommitteeMemberRoleActions.LoadCommitteeMemberRoleById, dispatch),
        clearCommitteeMemberRole: bindActionCreators(CommitteeMemberRoleActions.Clear, dispatch),

        loadCommittee: bindActionCreators(CommitteeActions.LoadCommitteeById, dispatch),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        loadCommitteeMember: bindActionCreators(CommitteeMemberActions.LoadCommitteeMemberById, dispatch),
        clearCommitteeMember: bindActionCreators(CommitteeMemberActions.Clear, dispatch),

        saveCommitteeMemberRole: bindActionCreators(CommitteeMemberRoleActions.SaveCommitteeMemberRole, dispatch),
        createCommitteeMemberRole: bindActionCreators(CommitteeMemberRoleActions.CreateCommitteeMemberRole, dispatch),
        validateCommitteeMemberRole: bindActionCreators(CommitteeMemberRoleActions.ValidateCommitteeMemberRole, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommitteeMemberRolePage);
